import { faClock, faUsers, faUserTie, faBuilding, faFileAlt, faXmarkCircle, faCheck, faCloudMoonRain, faUserShield, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react'
import { Tabs, Tab, Button, Form, Row, Col } from 'react-bootstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import OperatorTable from '../../../../../components/table/Operator.table';
import CenterDataV2 from '../CenterDataV2';
import ReverificationDetails from '../ReverificationDetails';
import toast from 'react-hot-toast';
import AdminService from '../../../../../services/admin.service';
import ConfirmModal from '../../../../../components/Modal/Confirm.modal';
import DatePicker from "react-datepicker"
import moment from 'moment';
import ExamShifts from './ExamShifts';
import ExamClients from './ExamClients';
import ExamVerificationClients from './ExamVerificationClients';
import ExamService from '../../../../../services/exam.service';
import { FaMapPin } from 'react-icons/fa';
import MhcetMapping from '../MhcetMapping';
import MhcetDBSSyncing from '../MhcetDBSSyncing';
import makeUploadRequest from '../../../../../api/make.upload';


interface IProps {
    exam: any;
    refreshExam: () => void
}


export default function ExamDetails({ exam, refreshExam }: IProps) {

    const params = useParams();

    const [activeTab, setActiveTab] = useState<string>("shifts");
    const [showCreateOperator, setShowCreteOperator] = useState<boolean>(false);
    const [newOperatorEmail, setNewOperatorEmail] = useState<string>("");
    const [newUserName, setnewUserName] = useState<string>("");
    const [data, setData] = useState<any>(null);
    const [collegeName, setCollegeName] = useState<string>("");
    const [collegeId, setCollegeId] = useState<string>("");
    const [operators, setOperators] = useState<any>();
    const [serachParams, setSearchParams] = useSearchParams();
    const [showCsvModal, setShowCsvModal] = useState<boolean>(false);
    const [csvFile, setCsvFile] = useState<File | null>(null);
    const [csvLoading, setCsvLoading] = useState<boolean>(false);
    const [additionalImagesZip, setAdditionalImagesZip] = useState<File | null>(null);
    const [allowOverwrite, setAllowOverwrite] = useState<boolean>(false);
    const [additionalImagesLoading, setAdditionalImagesLoading] = useState<boolean>(false);
    const [additionalImagesResponse, setAdditionalImagesResponse] = useState<any>(null);


    function handleChangeData(e: any) {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const handleCreateOperator = async () => {
        if (!newOperatorEmail || !newUserName || !data?.startTime || !data?.endTime || !collegeName || !collegeId) {
            toast.error("All fields are required");
            return;
        }
        await AdminService.createOperator(params.examId, {

            emailId: newOperatorEmail,
            userName: newUserName,
            accessStartTime: data.startTime,
            accessEndTime: data.endTime,
            examId: params.examId,
            collegeName: collegeName,
            collegId: collegeId,
            // stream: stream
        })
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Opertro created successfully");
                    getAllOperators();
                    setShowCreteOperator(false);

                    setNewOperatorEmail("");
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Unable to creaet Opertaor");
            });
    };

    const getAllOperators = async () => {
        await AdminService.getAllOperatoprs(params.examId).then((res) => {
            if (res.status === 200) {
                console.log(res.data);
                setOperators(res?.data?.data?.operators || []);
            }
        });
    };

    useEffect(() => {
        if (activeTab === 'operators') {
            getAllOperators();
        }
    }, [activeTab]);

    useEffect(() => {
        setSearchParams({ tab: activeTab });
    }, [activeTab]);

    useEffect(() => {
        setActiveTab(serachParams.get('tab') || 'shifts');
    }, []);

    const handleMissingVerificationCsv = async () => {
        if (!csvFile) {
            toast.error("Please select a CSV file");
            return;
        }
        setCsvLoading(true);
        const formData = new FormData();
        formData.append("userData", csvFile);
        try {
            const res = await makeUploadRequest(
                `/admin/csv/reverification/missing/verification/${params.examId}`,
                "post",
                formData
            );
            const rows: any[] = res.data?.data?.data || [];
            if (!rows.length) {
                toast.error("No data returned");
                return;
            }
            const headers = Object.keys(rows[0]);
            const csvContent = [
                headers.join(","),
                ...rows.map(row => headers.map(h => JSON.stringify(row[h] ?? "")).join(","))
            ].join("\n");
            const blob = new Blob([csvContent], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "missing_verification.csv";
            a.click();
            URL.revokeObjectURL(url);
            toast.success("CSV downloaded");
            setShowCsvModal(false);
            setCsvFile(null);
        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Failed to process CSV");
        } finally {
            setCsvLoading(false);
        }
    };

    const handleAdditionalImagesUpload = async () => {
        if (!additionalImagesZip) {
            toast.error("Please select a ZIP file");
            return;
        }
        setAdditionalImagesLoading(true);
        const formData = new FormData();
        formData.append("zip", additionalImagesZip);
        try {
            const res = await ExamService.uploadAdditionalImages(params.examId, formData, allowOverwrite);
            setAdditionalImagesResponse(res?.data?.data);
            toast.success("Additional images uploaded successfully");
            setAdditionalImagesZip(null);
        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Failed to upload images");
        } finally {
            setAdditionalImagesLoading(false);
        }
    };

    const createApiKey = async () => {
        await ExamService.createApiKey(params.examId)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("API Key Created Successfully");
                    refreshExam();
                }
            }).catch((err) => {
                toast.error("Unable to create API Key");
            })
    }


    return (
        <>
            <div
                style={{
                    width: "100%",
                    minHeight: 500,
                    paddingLeft: "30px",
                    borderLeft: "1px solid #cccccc",
                }}
            >
                <div className="mb-4">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k || "shifts")}
                        className="mb-0 mt-2"
                    // variant="pills"
                    >
                        <Tab
                            eventKey="shifts"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faClock} className="me-2" />
                                    Shifts
                                </span>
                            }
                        >
                            {
                                activeTab == 'shifts' &&
                                <ExamShifts exam={exam} refreshExam={refreshExam} />
                            }
                        </Tab>

                        <Tab
                            eventKey="clients"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faUsers} className="me-2" />
                                    Clients
                                </span>
                            }
                        >
                            {
                                activeTab == 'clients' &&
                                <ExamClients />
                            }
                        </Tab>

                        <Tab
                            eventKey="verification-clients"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faUserShield} className="me-2" />
                                    Verification Clients
                                </span>
                            }
                        >
                            {
                                activeTab == 'verification-clients' &&
                                <ExamVerificationClients />
                            }
                        </Tab>

                        <Tab
                            eventKey="centers"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faBuilding} className="me-2" />
                                    Center Operators
                                </span>
                            }
                        >
                            {
                                activeTab == 'centers' &&
                                <div className="mt-3">
                                    <CenterDataV2 examId={params?.examId} />
                                </div>
                            }
                        </Tab>

                        <Tab
                            eventKey="operators"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faUserTie} className="me-2" />
                                    Re-Verification Operator
                                </span>
                            }
                        >
                            {
                                activeTab == 'operators' &&
                                <div className="mt-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p
                                            style={{ fontSize: "18px", fontWeight: "bold" }}
                                            className="mt-2"
                                        >
                                            Re-Verification Operator
                                        </p>
                                        <div className="d-flex gap-2">
                                            <Button
                                                variant="outline-secondary"
                                                className="fw-bold"
                                                size="sm"
                                                onClick={() => setShowCsvModal(true)}
                                            >
                                                Check Missing Verification
                                            </Button>
                                            <Button
                                                variant="outline-primary"
                                                className="fw-bold"
                                                size="sm"
                                                onClick={() => setShowCreteOperator(true)}
                                            >
                                                create-operator
                                            </Button>
                                        </div>
                                    </div>
                                    <div>
                                        <OperatorTable
                                            operators={operators}
                                            examId={params.examId}
                                            reload={getAllOperators}
                                        />
                                    </div>
                                </div>
                            }
                        </Tab>

                        <Tab
                            eventKey="reverification"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                    Reverification Details
                                </span>
                            }
                        >
                            {
                                activeTab == "reverification" &&
                                <div className="mt-3">
                                    <ReverificationDetails examId={params?.examId} />
                                </div>
                            }
                        </Tab>

                         <Tab
                            eventKey="apikey"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faCloudMoonRain} className="me-2" />
                                    API Key
                                </span>
                            }
                        >
                            {
                                activeTab == "apikey" &&
                                <div className="mt-3">
                                    <Button
                                        variant="outline-primary"
                                        className="fw-bold"
                                        size="sm"
                                        onClick={createApiKey}
                                    >
                                        Create API Key
                                    </Button>
                                      {exam?.apiKey && (
                                        <div style={{
                                            marginTop: "24px",
                                            padding: "16px",
                                            backgroundColor: "#f8f9fa",
                                            borderRadius: "8px",
                                            border: "1px solid #dee2e6",
                                        }}>
                                            <div className="mb-4">
                                                <label className="fw-bold d-block mb-2" style={{ fontSize: "14px", color: "#495057" }}>
                                                    Your API Key
                                                </label>
                                                <div style={{
                                                    padding: "12px",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "6px",
                                                    border: "1px solid #dee2e6",
                                                    wordBreak: "break-all",
                                                    fontFamily: "monospace",
                                                    fontSize: "13px",
                                                    color: "#212529",
                                                    userSelect: "all",
                                                }}>
                                                    {exam?.apiKey}
                                                </div>
                                            </div>
                                            <div className="mb-4">
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="fw-bold"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(exam?.apiKey);
                                                        toast.success("API Key copied to clipboard");
                                                    }}
                                                >
                                                    📋 Copy API Key
                                                </Button>
                                            </div>

                                            <div className="border-top pt-4">
                                                <label className="fw-bold d-block mb-2" style={{ fontSize: "14px", color: "#495057" }}>
                                                    Backend API Base URL
                                                </label>
                                                <div style={{
                                                    padding: "12px",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "6px",
                                                    border: "1px solid #dee2e6",
                                                    wordBreak: "break-all",
                                                    fontFamily: "monospace",
                                                    fontSize: "13px",
                                                    color: "#212529",
                                                    userSelect: "all",
                                                }}>
                                                    {process.env.REACT_APP_API_URL}
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="fw-bold"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(process.env.REACT_APP_API_URL || "");
                                                        toast.success("Base URL copied to clipboard");
                                                    }}
                                                >
                                                    📋 Copy Base URL
                                                </Button>
                                            </div>
                                        </div>
                                      )}
                                      {!exam?.apiKey && (
                                        <div style={{
                                            marginTop: "24px",
                                            padding: "16px",
                                            backgroundColor: "#fff3cd",
                                            borderRadius: "8px",
                                            border: "1px solid #ffc107",
                                            color: "#856404",
                                        }}>
                                            <p className="mb-0" style={{ fontSize: "14px" }}>
                                                ⚠️ No API Key created yet. Click the <strong>"Create API Key"</strong> button above to generate one.
                                            </p>
                                        </div>
                                      )}
                                </div>
                                
                            }
                        </Tab>

                         <Tab
                            eventKey="mhcet"
                            title={
                                <span>
                                    <FaMapPin className="me-2" />
                                    Mhcet Mapping
                                </span>
                            }
                        >
                            {
                                activeTab == "mhcet" &&
                                <div className="mt-3">
                                    <MhcetMapping  examId={params?.examId} exam = {exam} />
                                </div>
                            }
                        </Tab>
                        <Tab
                            eventKey="additional-images"
                            title={
                                <span>
                                    <FontAwesomeIcon icon={faUpload} className="me-2" />
                                    Additional Images
                                </span>
                            }
                        >
                            {
                                activeTab == "additional-images" &&
                                <div className="mt-3">
                                    <p style={{ fontSize: "18px", fontWeight: "bold" }} className="mt-2">
                                        Upload Additional Images
                                    </p>
                                    <Form.Group className="mb-3">
                                        <label className="fw-bold xcn-text-12 text-secondary d-block mb-2">
                                            Select ZIP File
                                        </label>
                                        <Form.Control
                                            type="file"
                                            accept=".zip"
                                            onChange={(e: any) => setAdditionalImagesZip(e.target.files?.[0] || null)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="allowOverwrite"
                                            label="Allow Overwrite"
                                            checked={allowOverwrite}
                                            onChange={(e) => setAllowOverwrite(e.target.checked)}
                                        />
                                    </Form.Group>
                                    <Button
                                        variant="outline-primary"
                                        className="fw-bold"
                                        size="sm"
                                        disabled={additionalImagesLoading}
                                        onClick={handleAdditionalImagesUpload}
                                    >
                                        <FontAwesomeIcon icon={faUpload} className="me-2" />
                                        {additionalImagesLoading ? "Uploading..." : "Upload"}
                                    </Button>

                                    {additionalImagesResponse && (
                                        <div className="mt-4">
                                            <div className="d-flex align-items-center gap-3 mb-3">
                                                <span className="badge bg-primary">Total: {additionalImagesResponse.total}</span>
                                                <span className="badge bg-success">Successful: {additionalImagesResponse.successful}</span>
                                                <span className="badge bg-danger">Failed: {additionalImagesResponse.failed}</span>
                                                {additionalImagesResponse.csv && (
                                                    <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={() => {
                                                            const csvContent = atob(additionalImagesResponse.csv);
                                                            const blob = new Blob([csvContent], { type: "text/csv" });
                                                            const url = URL.createObjectURL(blob);
                                                            const a = document.createElement("a");
                                                            a.href = url;
                                                            a.download = "additional_images_report.csv";
                                                            a.click();
                                                            URL.revokeObjectURL(url);
                                                        }}
                                                    >
                                                        Download CSV Report
                                                    </Button>
                                                )}
                                            </div>
                                            {additionalImagesResponse.results?.length > 0 && (
                                                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                    <table className="table table-sm table-bordered">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>Filename</th>
                                                                <th>Roll No</th>
                                                                <th>Status</th>
                                                                <th>Reason</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {additionalImagesResponse.results.map((item: any, idx: number) => (
                                                                <tr key={idx}>
                                                                    <td>{item.filename}</td>
                                                                    <td>{item.rollNo}</td>
                                                                    <td>
                                                                        <span className={`badge bg-${item.status === "success" ? "success" : "danger"}`}>
                                                                            {item.status}
                                                                        </span>
                                                                    </td>
                                                                    <td>{item.reason || "-"}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            }
                        </Tab>

                         <Tab
                            eventKey="mhcet-dbs"
                            title={
                                <span>
                                    <FaMapPin className="me-2" />
                                    Mhcet DBS Syncing
                                </span>
                            }
                        >
                            {
                                activeTab == "mhcet-dbs" &&
                                <div className="mt-3">
                                    <MhcetDBSSyncing  examId={params?.examId} exam = {exam} />
                                </div>
                            }
                        </Tab>
                    </Tabs>
                </div>
            </div >

            <ConfirmModal
                titleText={"Check Missing Verification"}
                size="md"
                bodyText={
                    <>
                        <Form.Group controlId="missingVerifCsv">
                            <label className="fw-bold xcn-text-12 text-secondary d-block mb-2">
                                Select CSV File
                            </label>
                            <Form.Control
                                type="file"
                                accept=".csv"
                                onChange={(e: any) => setCsvFile(e.target.files?.[0] || null)}
                            />
                        </Form.Group>
                    </>
                }
                show={showCsvModal}
                onHide={() => { setShowCsvModal(false); setCsvFile(null); }}
                button={[
                    {
                        label: <><FontAwesomeIcon icon={faXmarkCircle} /> Cancel</>,
                        action: () => { setShowCsvModal(false); setCsvFile(null); },
                        variant: "secondary",
                    },
                    {
                        label: csvLoading ? "Processing..." : <><FontAwesomeIcon icon={faCheck} /> Proceed</>,
                        action: handleMissingVerificationCsv,
                        variant: "success",
                    },
                ]}
            />

            <ConfirmModal
                titleText={"Create operator modal"}
                size="lg"
                bodyText={
                    <>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <label className="fw-bold xcn-text-12 text-secondary">
                                Operator Username
                            </label>
                            <Form.Control
                                type="userName"
                                value={newUserName}
                                onChange={(e: any) => setnewUserName(e.target.value)}
                            />
                        </Form.Group>


                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <label className="fw-bold xcn-text-12 text-secondary">
                                Operator Email
                            </label>
                            <Form.Control
                                type="email"
                                value={newOperatorEmail}
                                onChange={(e: any) => setNewOperatorEmail(e.target.value)}

                            />

                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <label className="fw-bold xcn-text-12 text-secondary">
                                College Name
                            </label>
                            <Form.Control
                                type="text"
                                value={collegeName}
                                onChange={(e: any) => setCollegeName(e.target.value)}

                            />
                        </Form.Group>

                        <Row>
                            <Col>

                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <label className="fw-bold xcn-text-12 text-secondary">
                                        College ID
                                    </label>
                                    <Form.Control
                                        type="text"
                                        value={collegeId}
                                        onChange={(e: any) => setCollegeId(e.target.value)}

                                    />

                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col md>
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    Start Time
                                </label>
                                <DatePicker
                                    dateFormat="yyyy/MM/dd h:mm aa"
                                    showTimeSelect
                                    selected={moment(data?.startTime).toDate()}
                                    name="startTime"
                                    onChange={(e) => {
                                        handleChangeData({
                                            target: { name: "startTime", value: e },
                                        });
                                    }}
                                    className="form-control xcn-text-12"
                                    minDate={new Date()}
                                />
                            </Col>
                            <Col md>
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    End Time
                                </label>
                                <DatePicker
                                    dateFormat="yyyy/MM/dd h:mm aa"
                                    showTimeSelect
                                    name="endTime"
                                    selected={moment(data?.endTime).toDate()}
                                    onChange={(e) => {
                                        handleChangeData({
                                            target: { name: "endTime", value: e },
                                        });
                                    }}
                                    className="form-control xcn-text-12"
                                    minDate={new Date()}
                                />
                            </Col>
                        </Row>
                    </>
                }
                show={showCreateOperator}
                onHide={() => setShowCreteOperator(false)}
                button={[
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
                            </>
                        ),
                        action: () => setShowCreteOperator(false),
                        variant: "secondary",
                    },
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faCheck} /> Create
                            </>
                        ),
                        action: handleCreateOperator,
                        variant: "success",
                    },
                ]}
            />
        </>
    )
}